import { render, staticRenderFns } from "./qa-table.vue?vue&type=template&id=28fcf5dc&scoped=true"
import script from "./qa-table.vue?vue&type=script&lang=js"
export * from "./qa-table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28fcf5dc",
  null
  
)

export default component.exports